import React, { useState } from "react";
import PropTypes from "prop-types";
import { useAuth } from "../context/AuthContext";
import { IoIosWarning } from "react-icons/io";
import { FaSearch, FaUser, FaSignOutAlt } from "react-icons/fa";
import moment from "moment";
import 'moment/locale/fr';
moment.locale('fr');

const Navbar = ({
  isOnTicketPage,
  searchTerm,
  handleSearchChange,
  showSearchResults,
  setShowSearchResults,
  filteredTickets,
  selectTicket,
  typesTicket,
  TICKET_STATUTS,
  isSidebarCollapse
}) => {
  const { userInfo, logOut, clientInfo } = useAuth();
  const [showLogoutBox, setShowLogoutBox] = useState(false);

  return (
    <nav className={`navbar navbar-expand navbar-light bg-white topbar shadow-sm navbar-topbar${isSidebarCollapse ? " navbar-topbar--collapsed" : ""}`}>

      {/* Recherche */}
      <div className="d-none d-sm-flex align-items-center flex-grow-1 position-relative me-3 ms-3">
        <div className="input-group navbar-search-input">
          <input
            type="text"
            className="form-control"
            placeholder="Chercher un ticket..."
            value={searchTerm}
            onChange={handleSearchChange}
            onFocus={() => searchTerm.trim() !== "" && setShowSearchResults(true)}
            id="recherche"
            data-testid="recherche"
          />
          <button className="btn btn-primary" type="button">
            <FaSearch />
          </button>
        </div>

        {/* Résultats */}
        {showSearchResults && searchTerm.trim() !== "" && (
          <div className="search-results-dropdown">
            <div className="search-results-header">
              <span className="fw-semibold text-dark small">Résultats de recherche</span>
              <button
                type="button"
                className="btn-close btn-sm"
                onClick={() => setShowSearchResults(false)}
                aria-label="Fermer"
              />
            </div>
            <div className="search-results-body">
              {filteredTickets.length === 0 ? (
                <div className="search-no-results">Aucun ticket trouvé</div>
              ) : (
                <ul className="search-results-list">
                  {filteredTickets.map((ticket) => (
                    <li
                      key={ticket.idTicket}
                      className="search-result-item"
                      onClick={() => selectTicket(ticket)}
                    >
                      <div className="search-result-title d-flex align-items-center gap-2">
                        {ticket.titre}
                        {ticket.priorite === 1 && (
                          <IoIosWarning style={{ color: "red", fontSize: 18 }} title="Ticket prioritaire" />
                        )}
                      </div>
                      <div className="search-result-details">
                        <span className="badge bg-secondary">{TICKET_STATUTS[ticket.idStatut] || "N/A"}</span>
                        <span className="text-muted">
                          {ticket.idStatut === 0
                            ? moment(ticket.dateDebut).format("ddd DD MMM YYYY à HH:mm")
                            : ticket.idStatut === 1
                            ? moment(ticket.intervention?.at(-1)?.date).format("ddd DD MMM YYYY à HH:mm")
                            : moment(ticket.dateCloture).format("ddd DD MMM YYYY à HH:mm")}
                        </span>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Droite — user info */}
      <ul className="navbar-nav ms-auto align-items-center">
        <li className="nav-item d-none d-lg-flex align-items-center">
          <span className="text-muted small me-2">{clientInfo?.name}</span>
          <div className="topbar-divider" />
        </li>

        <li className="nav-item position-relative">
          <button
            className="btn btn-link nav-link d-flex align-items-center gap-2 text-dark"
            onClick={() => setShowLogoutBox(!showLogoutBox)}
            data-testid="deconnexion-text"
          >
            <div
              className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white"
              style={{ width: 36, height: 36, fontSize: 14, flexShrink: 0 }}
            >
              <FaUser />
            </div>
            <span className="d-none d-lg-inline small text-gray-600">{userInfo?.userName}</span>
          </button>

          {showLogoutBox && (
            <div
              className="dropdown-menu dropdown-menu-end shadow animated--grow-in show"
              style={{ right: 0, left: "auto", minWidth: "200px" }}
            >
              <div className="dropdown-header text-muted small py-2 px-3">
                {userInfo?.userName}
              </div>
              <div className="dropdown-divider" />
              <button
                data-testid="deconnexion-button"
                className="dropdown-item"
                onClick={logOut}
              >
                <FaSignOutAlt className="me-2 text-secondary" />
                Se déconnecter
              </button>
            </div>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
